import { createContext } from 'react';

export const BackendWebSocketContext = createContext({
  dispatchMessage: () => {},
  registerHandler: () => {},
  unregisterHandler: () => {},
});
